import '@fontsource/ibm-plex-mono';
import '/node_modules/react-grid-layout/css/styles.css';
import '/node_modules/react-resizable/css/styles.css';
import '@xyflow/react/dist/style.css';
import '@/index.css';

import LogRocket from 'logrocket';
import ReactDOM from 'react-dom/client';

import { App } from '@/app/App';
import { PRODUCTION_ORIGINS } from '@/app/constant';

function initializeSystemTheme() {
  // Set initial theme based on system preference
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    document.documentElement.dataset.theme = 'dark';
    document.documentElement.setAttribute('data-color-mode', 'dark');
  } else {
    document.documentElement.dataset.theme = 'light';
    document.documentElement.setAttribute('data-color-mode', 'light');
  }

  // Listen for system theme changes
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', e => {
      document.documentElement.dataset.theme = e.matches ? 'dark' : 'light';
    });
}

// Initialize theme before rendering
initializeSystemTheme();

// Initialize LogRocket only in production
if (PRODUCTION_ORIGINS.includes(window.location.origin)) {
  LogRocket.init(import.meta.env.VITE_LOGROCKET_APP_ID, {
    network: {
      // Sanitize network requests to redact sensitive fields
      requestSanitizer: request => {
        // Redact sensitive fields from request body
        if (typeof request.body === 'string') {
          request.body = request.body.replace(
            /"(password|secret|token|api_key|apikey|access_token|refresh_token|client_secret|private_key)"\s*:\s*"[^"]*"/gi,
            '"$1":"[REDACTED]"'
          );
        }
        return request;
      },
    },
    dom: {
      inputSanitizer: true, // Automatically masks password inputs
    },
  });
}

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement ?? document.createElement('div'));

root.render(<App />);
